
import React from 'react';
import { FamilyMember } from './types';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

interface RemoveMemberDialogProps {
  member: FamilyMember | null;
  onMemberChange: (member: FamilyMember | null) => void;
  onRemoveMember: () => Promise<void>;
}

const RemoveMemberDialog = ({ member, onMemberChange, onRemoveMember }: RemoveMemberDialogProps) => {
  const open = !!member;

  const handleRemove = async () => {
    await onRemoveMember();
  };

  return (
    <AlertDialog open={open} onOpenChange={(open) => !open && onMemberChange(null)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove Family Member</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to remove this person from your family group?
            {member?.status === 'active' && (
              <span className="block mt-2 font-semibold">
                They will no longer have access to your family's data.
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleRemove} className="bg-destructive text-destructive-foreground">
            Remove
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RemoveMemberDialog;
